/** Redux action-type strings (match store/postedNote) — used by FindLoad/FindSuccess in the UI. */
export const CREATE_POSTED_NOTE_ACTION = 'CREATE_POSTED_NOTE';
export const EDIT_POSTED_NOTE_ACTION = 'EDIT_POSTED_NOTE';
export const DELETE_POSTED_NOTE_ACTION = 'DELETE_POSTED_NOTE';

/** Max plain-text length of a posted note (matches the "0/500" counter in the design). */
export const POSTED_NOTE_MAX = 500;

/** Copy shared across the add/edit modal and the detail card. */
export const POSTED_NOTE_SUBTITLE = 'This note will be visible to the therapist during every data collection session.';
export const POSTED_NOTE_VISIBILITY = 'Visible to the therapist during data collection';
export const POSTED_NOTE_TOOLTIP = 'Add a note that stays visible to the therapist during the session.';

/** Strip HTML tags to count the note's plain-text length for the character counter / limit. */
export const postedNotePlainLength = (html) =>
    (html || '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .trim().length;
